/**
 * @generated SignedSource<<6f4bdb6aa059bc2bf4cd211ace2423e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type AddPlayersPrivateStepNode$data = {
  readonly agenda?: {
    readonly facility: {
      readonly type: FacilityType;
    };
  };
  readonly requirePlayerCounts?: boolean;
  readonly standardCapacity?: number;
  readonly usedCapacity?: number;
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersHeaderNode">;
  readonly " $fragmentType": "AddPlayersPrivateStepNode";
};
export type AddPlayersPrivateStepNode$key = {
  readonly " $data"?: AddPlayersPrivateStepNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddPlayersPrivateStepNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersHeaderNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePlayerCounts",
          "storageKey": null
        },
        {
          "alias": "standardCapacity",
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usedCapacity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "c1523cb8f1e557cf6a030578a3bef2cc";

export default node;
